export default __webpack_public_path__ + "static/media/gallery_03@2x.a80a7bf7.jpg";